import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { ExpandingFAQ, FrequentlyAskedQuestionsContainer } from './FrequentlyAskedQuestions';
import { useFaqToggleHandler, useLinkClickHandler } from './FrequentlyAskedQuestionsUtils';
import { getAcademyUrlPublic, getCommunityUrlPublic, getKnowledgeBaseUrlPublic, getLanguagesUrlPublic, getNonProfitsUrlPublic, getSalesUrlPublic, getStartupsUrlPublic } from './FrequentlyAskedQuestionsPublicPageUrls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const communityHref = getCommunityUrlPublic();
const langHref = getLanguagesUrlPublic();
const academyHref = getAcademyUrlPublic();
const kbHref = getKnowledgeBaseUrlPublic();
const salesHref = getSalesUrlPublic();
const startupsHref = getStartupsUrlPublic('pricing-salespage');
const nonprofitsHref = getNonProfitsUrlPublic('pricing-salespage');
export const SalesHubFaqs = ({
  onLinkClick,
  onFaqInteraction
} = {}) => {
  const handleFaqToggle = useFaqToggleHandler(onFaqInteraction);
  const handleLinkClick = useLinkClickHandler(onLinkClick);
  return /*#__PURE__*/_jsxs(FrequentlyAskedQuestionsContainer, {
    children: [/*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatIsSalesHub.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatIsSalesHub.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          salesLink: /*#__PURE__*/_jsx(Link, {
            href: salesHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatIsSalesHub', salesHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatIsSalesHub.learnMore"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('sales.whatIsSalesHub', 'pricing-page-components.frequentlyAskedQuestions.sales.whatIsSalesHub.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatIsFreeVsPaid.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatIsFreeVsPaid.answer"
      }),
      onExpandedChange: () => handleFaqToggle('sales.whatIsFreeVsPaid', 'pricing-page-components.frequentlyAskedQuestions.sales.whatIsFreeVsPaid.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.howManyUsers.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.howManyUsers.answer"
      }),
      onExpandedChange: () => handleFaqToggle('sales.howManyUsers', 'pricing-page-components.frequentlyAskedQuestions.sales.howManyUsers.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.salesVsService.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.salesVsService.answer"
      }),
      onExpandedChange: () => handleFaqToggle('sales.salesVsService', 'pricing-page-components.frequentlyAskedQuestions.sales.salesVsService.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.answer",
        options: {
          br: /*#__PURE__*/_jsx("br", {}),
          communityLink: /*#__PURE__*/_jsx(Link, {
            href: communityHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatSupport.hubSpotCommunity', communityHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.hubSpotCommunity"
            })
          }),
          languageLink: /*#__PURE__*/_jsx(Link, {
            href: langHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatSupport.languageOffering', langHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.languageOffering"
            })
          }),
          academyLink: /*#__PURE__*/_jsx(Link, {
            href: academyHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatSupport.hubSpotAcademy', academyHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.hubSpotAcademy"
            })
          }),
          kbLink: /*#__PURE__*/_jsx(Link, {
            href: kbHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatSupport.hubSpotKnowledgeBase', kbHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.hubSpotKnowledgeBase"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('sales.whatSupport', 'pricing-page-components.frequentlyAskedQuestions.sales.whatSupport.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatDiscounts.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whatDiscounts.answer",
        options: {
          startupsLink: /*#__PURE__*/_jsx(Link, {
            href: startupsHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatDiscounts.hubSpotForStartups', startupsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatDiscounts.hubSpotForStartups"
            })
          }),
          nonprofitsLink: /*#__PURE__*/_jsx(Link, {
            href: nonprofitsHref,
            external: true,
            onClick: () => handleLinkClick('sales.whatDiscounts.hubSpotForNonprofits', nonprofitsHref),
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "pricing-page-components.frequentlyAskedQuestions.sales.whatDiscounts.hubSpotForNonprofits"
            })
          })
        }
      }),
      onExpandedChange: () => handleFaqToggle('sales.whatDiscounts', 'pricing-page-components.frequentlyAskedQuestions.sales.whatDiscounts.question')
    }), /*#__PURE__*/_jsx(ExpandingFAQ, {
      Title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whenEligibleForNewPricing.question"
      }),
      Content: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricing-page-components.frequentlyAskedQuestions.sales.whenEligibleForNewPricing.answer"
      }),
      onExpandedChange: () => handleFaqToggle('sales.whenEligibleForNewPricing', 'pricing-page-components.frequentlyAskedQuestions.sales.whenEligibleForNewPricing.question')
    })]
  });
};